module.exports = __webpack_public_path__ + "img/Assembling_new_stock.e974108a.svg";